export const selectEviteEvent = ({eviteEvent}) => eviteEvent;
export const selectEventTemplateName = (state) => selectEviteEvent(state).template_name || '';
export const selectEventType = (state) => selectEviteEvent(state).event_type || '';
export const selectIsFuneral = (state) => selectEventType(state) === 'funeral_memorial_service';
export const selectOptions = (state) => selectEviteEvent(state).options;
export const selectShowGifting = (state) => !!selectOptions(state)?.event_option_show_gifting;
export const selectRoktDisabled = (state) => !!selectOptions(state)?.event_option_disable_rokt;
export const selectIsPremium = (state) => !!selectEviteEvent(state).isPremium;
export const selectPledgelingData = (state) => selectEviteEvent(state).pledgeling_data;
export const selectPledgelingDataOrganization = (state) =>
  selectPledgelingData(state)?.Organization;
export const selectPledgelingDataCrowdfund = (state) => selectPledgelingData(state)?.Crowdfund;
export const selectCharityId = (state) => selectPledgelingDataOrganization(state)?.pledgeling_id;
export const selectCrowdFundPurpose = (state) =>
  selectPledgelingDataCrowdfund(state)?.pledgeling_purpose;
export const selectPhoneNumber = (state) => selectEviteEvent(state).phone_number;
export const selectCohost = (state) => {
  return {
    name: selectEviteEvent(state).cohost_name1 || '',
    email: selectEviteEvent(state).cohost_email1 || '',
  };
};
export const selectHostIds = (state) => selectEviteEvent(state).host_ids ?? [];
export const selectStatus = (state) => selectEviteEvent(state).status;
export const selectIsPrivateGuestlist = (state) =>
  selectOptions(state)?.event_option_private_guestlist ?? false;
